import { Component, inject } from '@angular/core';
import { IonButton, IonModal } from '@ionic/angular/standalone';
import { AppBrandLogoComponent } from '../common/components/app-brand-logo/app-brand-logo.component';
import { TRANSLATE_IMPORTS } from '../i18n/translate-imports';
import { AppUpdateService } from './app-update.service';

@Component({
  selector: 're-app-update-modal',
  templateUrl: './app-update-modal.component.html',
  styleUrl: './app-update-modal.component.scss',
  imports: [IonModal, IonButton, AppBrandLogoComponent, ...TRANSLATE_IMPORTS],
})
export class AppUpdateModalComponent {
  readonly appUpdate = inject(AppUpdateService);
}
